import { render, staticRenderFns } from "./change-sticker.vue?vue&type=template&id=7d3d37a8&"
import script from "./change-sticker.vue?vue&type=script&lang=js&"
export * from "./change-sticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports